import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import TopBar from './TopBar';
import Footer from './Footer';

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
    return null;
};

const PageLayout = () => (
    <>
        <ScrollToTop />
        <TopBar />
        <Outlet />
        <Footer />
    </>
);

export default PageLayout;
